(function () {
  function init() {
    document.querySelectorAll('[data-pg-tabs]:not([data-bound])').forEach(function (root) {
      root.setAttribute('data-bound', '1');
      var btns = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');
      btns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var key = b.getAttribute('data-tab');
          btns.forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-on', on);
            x.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-on', p.getAttribute('data-panel') === key);
          });
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
